<template>
  <div class="menulistctrl">

    <Card :bordered="false">
      <div slot="title">
        <div class="des-cardTittle-box">
          <div class="leftFlex">
            <Divider orientation="left">{{ langMap.cdgl[lang] }}</Divider>
          </div>
          <div class="rightFLex">
            <Button
              type="primary"
              @click="addMenulist"
            >{{ langMap.addMenu[lang] }}</Button>
          </div>
        </div>
      </div>
      <Table
        :height="height"
        :loading="tableLoading"
        border
        :columns="menuListColumns"
        :data="menulistData"
      ></Table>
    </Card>

    <!--modal区域-->
    <Modal
      :title="langMap.addMenu[lang]"
      v-model="addMenuModal"
      :mask-closable="false"
    >

      <Tabs v-model="addType">
        <TabPane
          :label="langMap.parentMenu[lang] + ':'"
          name="menu1"
        >
          <Form
            ref="roleForm"
            :model="parentMenu"
            :label-width="80"
          >
            <FormItem :label="langMap.zhName[lang] + ':'">
              <Input
                v-model.trim="parentMenu.menuName"
                :placeholder="langMap.zhName[lang]"
              ></Input>
            </FormItem>
            <FormItem :label="langMap.enName[lang] + ':'">
              <Input
                v-model.trim="parentMenu.menuEnName"
                :placeholder="langMap.enName[lang]"
              ></Input>
            </FormItem>
            <FormItem :label="langMap.route[lang] + ':'" >
              <Input
                v-model.trim="parentMenu.menuUrl"
                :placeholder="langMap.route[lang]"
              ></Input>
            </FormItem>
            <FormItem :label="langMap.path[lang] + ':'" >
              <Input
                v-model.trim="parentMenu.menuPath"
                :placeholder="langMap.path[lang]"
              ></Input>
            </FormItem>
            <FormItem :label="langMap.isView[lang] + ':'" >
              <Select
                v-model="parentMenu.showFlag"
                style="width:100%"
              >
                <Option value=0>{{ langMap.hide[lang] }}</Option>
                <Option value=1>{{ langMap.show[lang] }}</Option>
              </Select>
            </FormItem>
            <FormItem :label="langMap.icon[lang] + ':'" >
              <Input
                v-model.trim="parentMenu.icon"
                :placeholder="langMap.icon[lang]"
              ></Input>
            </FormItem>
            <FormItem :label="langMap.sort[lang] + ':'" >
              <Input
                v-model.trim="parentMenu.menuOrder"
                :placeholder="langMap.sort[lang]"
              ></Input>
            </FormItem>
            <FormItem :label="langMap.description[lang] + ':'" >
              <Input
                v-model.trim="parentMenu.menuRemark"
                :placeholder="langMap.description[lang]"
              ></Input>
            </FormItem>
          </Form>
        </TabPane>
        <TabPane
          :label="langMap.childMenu[lang]"
          name="menu2"
        >
          <Form
            ref="roleForm"
            :model="childMenu"
            :label-width="80"
          >

            <FormItem :label="langMap.parentMenu[lang] + ':'" >
              <Select v-model="childMenu.parentId">
                <Option
                  v-for="parItem in parentList"
                  :key="parItem.menuId"
                  :value="parItem.menuId"
                >{{ getMenuDisplayName(parItem) }}</Option>
              </Select>
            </FormItem>
            <FormItem :label="langMap.zhName[lang] + ':'" >
              <Input
                v-model.trim="childMenu.menuName"
                :placeholder="langMap.zhName[lang]"
              ></Input>
            </FormItem>
            <FormItem :label="langMap.enName[lang] + ':'" >
              <Input
                v-model.trim="childMenu.menuEnName"
                :placeholder="langMap.enName[lang]"
              ></Input>
            </FormItem>
            <FormItem :label="langMap.route[lang] + ':'" >
              <Input
                v-model.trim="childMenu.menuUrl"
                :placeholder="langMap.route[lang]"
              ></Input>
            </FormItem>
            <FormItem :label="langMap.path[lang] + ':'" >
              <Input
                v-model.trim="childMenu.menuPath"
                :placeholder="langMap.path[lang]"
              ></Input>
            </FormItem>
            <FormItem :label="langMap.isView[lang] + ':'" >
              <Select
                v-model="childMenu.showFlag"
                style="width:100%"
              >
                <Option value=0>{{ langMap.hide[lang] }}</Option>
                <Option value=1>{{ langMap.show[lang] }}</Option>
              </Select>
            </FormItem>
            <FormItem :label="langMap.icon[lang] + ':'" >
              <Input
                v-model.trim="childMenu.icon"
                :placeholder="langMap.icon[lang]"
              ></Input>
            </FormItem>
            <FormItem :label="langMap.sort[lang] + ':'" >
              <Input
                v-model.trim="childMenu.menuOrder"
                :placeholder="langMap.sort[lang]"
              ></Input>
            </FormItem>
            <FormItem :label="langMap.description[lang] + ':'" >
              <Input
                v-model.trim="childMenu.menuRemark"
                :placeholder="langMap.description[lang]"
              ></Input>
            </FormItem>
          </Form>
        </TabPane>
      </Tabs>

      <div slot="footer">
        <Button @click="cencleMenu">{{ langMap.cancel[lang] }}</Button>
        <Button
          type="primary"
          @click="sureAddMenu"
        >{{ langMap.confirm[lang] }}</Button>
      </div>
    </Modal>

  </div>
</template>
<script>
//引入二级表格增强组件
import menuTabRender from "./menuTabRender";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
//引入api
import api from "../../../api/index.js";

export default {
  name: "menulistctrl",
  components: {
    menuTabRender
  },
  data() {
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 260 + "px",
      //table加载
      tableLoading: true,
      //菜单数据
      menulistData: [],
      //添加菜单modal
      addMenuModal: false,
      //父菜单数据
      parentMenu: {
        parentId: "", //父级ID
        menuLevel: "", //层级
        menuUrl: "", //菜单路由 path
        menuName: "", //菜单名称 title
        menuEnName: "", //菜单英文名称 title
        menuRemark: "", //备注 name
        icon: "", //图标
        menuPath: "", //路径
        menuOrder: "", //排序
        showFlag: 1
      },
      //获取父菜单列表
      parentList: [],
      //子菜单数据
      childMenu: {
        parentId: "", //父级id
        menuLevel: "",
        menuUrl: "", //菜单路由 path
        menuName: "", //菜单名称 title
        menuRemark: "", //备注 name
        icon: "", //图标
        menuPath: "", //路径
        menuOrder: "", //排序
        showFlag: 1
      },
      //获取添加的菜单类型
      addType: "menu1"
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    menuListColumns() {
      return [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(menuTabRender, {
              props: {
                row: params.row.children
              },
              on: {
                refreshList: this.getMenuTreeList
              }
            });
          }
        },
        {
          title: langMap.menuId[this.lang],
          minWidth: 120,
          key: "menuId"
        },
        {
          title: langMap.zhName[this.lang],
          minWidth: 120,
          key: "title",
          render: (h, params) => {
            return h("span", {}, params.row.att.menuName);
          }
        },
        {
          title: langMap.enName[this.lang],
          minWidth: 120,
          key: "menuEnName",
          render: (h, params) => {
            return h("span", {}, params.row.att.menuEnName);
          }
        },
        {
          title: langMap.route[this.lang],
          minWidth: 120,
          key: "path"
        },
        {
          title: langMap.path[this.lang],
          minWidth: 120,
          key: "name"
        },
        {
          title: langMap.isView[this.lang],
          minWidth: 120,
          key: "showFlag",
          render: (h, params) => {
            return h("span", {}, params.row.showFlag ? langMap.yes[this.lang] : langMap.no[this.lang]);
          }
        },
        {
          title: langMap.icon[this.lang],
          minWidth: 120,
          key: "icon"
        },
        {
          title: langMap.sort[this.lang],
          minWidth: 120,
          key: "att.menuOrder",
          render: (h, params) => {
            return h("span", {}, params.row.att.menuOrder);
          }
        },
        {
          title: langMap.operation[this.lang],
          width: 180,
          align: "center",
          render: (h, params) => {
            //禁用启用判断
            let rendText = langMap.enable[this.lang];
            if (params.row.att.menuState == 1) {
              rendText = langMap.disable[this.lang];
            }
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.deleteMenuConfirm[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          api
                            .getData(
                              "system-server/sys/removeMenu?menuId=" +
                                params.row.menuId,
                              this
                            )
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                this.getMenuTreeList();
                              }
                              this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                langMap.delete[this.lang]
              ),
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              }),
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.whether[this.lang] + rendText + langMap.menu[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          api
                            .getData(
                              "system-server/sys/updateMenuState?menuId=" +
                                params.row.menuId,
                              this
                            )
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                this.getMenuTreeList();
                              }
                              this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                rendText
              )
            ]);
          }
        }
      ];
    }
  },
  created() {
    this.getMenuTreeList();
  },
  methods: {
    getMenuDisplayName(menu) {
      if (this.lang === 'en') {
        return menu.menuEnName || menu.menuName || '';
      }
      return menu.menuName || '';
    },
    //添加菜单
    addMenulist() {
      this.addMenuModal = true;
      //获取菜单数据
      this.getMenuListByParentId();
    },

    //取消添加父菜单
    cencleMenu() {
      for (var i in this.parentMenu) {
        this.parentMenu[i] = "";
      }
      for (var i in this.childMenu) {
        this.childMenu[i] = "";
      }
      this.addMenuModal = false;
    },
    //添加父菜单
    sureAddMenu() {
      //定义提交shuju
      var postData = "";

      if (this.addType == "menu1") {
        //添加父菜单
        //然parentid为0
        //添加层级为1
        this.parentMenu.parentId = 0;
        this.parentMenu.menuLevel = 1;
        //父菜单添加/
        this.parentMenu.menuUrl = "/" + this.parentMenu.menuUrl;
        //赋值提交数据
        postData = this.parentMenu;
      } else {
        //添加父菜单
        //添加层级为1
        this.childMenu.menuLevel = 2;
        //赋值提交数据
        postData = this.childMenu;
      }
      //提交数据
      this.$Spin.show();
      api.postData("system-server/sys/saveMenu", postData, this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          //退出添加
          //提示操作成功
          //重载数据
          this.cencleMenu();
          this.getMenuTreeList();
          this.$Notice.success({
            title: langMap.tip[this.lang],
            desc: langMap.operationSuccess[this.lang]
          });
        }
        this.$Spin.hide();
      });
    },
    //获取菜单列表
    getMenuTreeList() {
      this.tableLoading = true;
      api.getData("system-server/sys/getMenuTreeList", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.menulistData = res.data;
        }
        this.tableLoading = false;
      });
    },

    //获取父菜单列表
    getMenuListByParentId() {
      this.$Spin.show();
      api
        .getData("system-server/sys/getMenuListByParentId?pId=0", this)
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.parentList = res.data;
          }
          this.$Spin.hide();
        });
    }
  }
};
</script>

<style lang="less" scoped>
@import "menulistctrl.less";
/deep/.ivu-table{
  overflow-y: auto;
}
</style>
